import { render, staticRenderFns } from "./PromptSettings.vue?vue&type=template&id=c08985bc&scoped=true"
import script from "./PromptSettings.vue?vue&type=script&lang=js"
export * from "./PromptSettings.vue?vue&type=script&lang=js"
import style0 from "./PromptSettings.vue?vue&type=style&index=0&id=c08985bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c08985bc",
  null
  
)

export default component.exports